import { render, staticRenderFns } from "./CredenciamentoFornecedorAcoesCancelarEnvio.vue?vue&type=template&id=8f8c66b2"
import script from "./CredenciamentoFornecedorAcoesCancelarEnvio.vue?vue&type=script&lang=js"
export * from "./CredenciamentoFornecedorAcoesCancelarEnvio.vue?vue&type=script&lang=js"
import style0 from "./CredenciamentoFornecedorAcoesCancelarEnvio.vue?vue&type=style&index=0&id=8f8c66b2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports